import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoFocus", "dataKey", "disabled", "inputMode", "dataSelenium", "name", "onChange", "placeholder", "renderExtraIcons", "type", "value", "displayMode", "onFocus", "onBlur"];
import { forwardRef } from 'react';
import { Data } from 'signup-constants/signupData/Data';
import { SignupDataInputIcon } from '../views/Forms.styles';
import { DisplayMode } from './DisplayMode';
import { TextInput as BaseTextInput } from 'foundations-components/transitional/components/TextInput';
import { View } from 'foundations-components/transitional/components/View';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      autoFocus,
      dataKey,
      disabled,
      inputMode,
      dataSelenium,
      name,
      onChange,
      placeholder,
      renderExtraIcons,
      type,
      value,
      displayMode = DisplayMode.Label,
      onFocus,
      onBlur
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldShowSidePanel = getShouldShowSidePanel();
  const {
    isExtraSmall
  } = useResponsiveness();
  const {
    currentStep
  } = useCurrentStep();
  const isExtraSmallInLandingPage = currentStep === Step.LandingPage && isExtraSmall;
  return /*#__PURE__*/_jsxs(View, {
    maxInlineSize: !shouldShowSidePanel || isExtraSmallInLandingPage ? '100%' : '360px',
    position: "relative",
    children: [/*#__PURE__*/_jsx(BaseTextInput, Object.assign({
      autoComplete: type === 'password' ? 'new-password' : 'on',
      autoFocus: autoFocus,
      "data-selenium": dataSelenium || dataKey,
      disabled: disabled,
      inputMode: inputMode,
      inputRef: ref,
      name: name
    }, displayMode === DisplayMode.Placeholder ? {
      placeholder
    } : null, {
      paddingInlineEnd: dataKey === Data.Password ? '1000' : undefined,
      type: type,
      value: value,
      onBlur: event => {
        if (onBlur) {
          onBlur(event, dataKey);
        }
      },
      onChange: ({
        target
      }) => onChange(target.value),
      onFocus: onFocus
    }, rest)), renderExtraIcons && /*#__PURE__*/_jsx(SignupDataInputIcon, {
      children: renderExtraIcons()
    })]
  });
});
export default TextInput;